// extracted by mini-css-extract-plugin
export default {"infoIconContainer":"InfoIcon_infoIconContainer__3WI18","infoIconI":"InfoIcon_infoIconI__T5NST"};